import { render, staticRenderFns } from "./RealtimeReport.vue?vue&type=template&id=66760e45&"
import script from "./RealtimeReport.vue?vue&type=script&lang=js&"
export * from "./RealtimeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports